/* IronVow — Forged */
(function () {
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  var cfg = window.IronVow || {};

  /* The buyer's active presentment currency (set by Shopify Markets). */
  function activeCurrency() {
    if (window.Shopify && Shopify.currency && Shopify.currency.active) return Shopify.currency.active;
    return cfg.currency || 'USD';
  }

  /* Formats cents in the buyer's local currency so multi-market prices show the right symbol. */
  function money(cents, currency) {
    var cur = currency || activeCurrency();
    var amount = (isNaN(cents) || cents === null ? 0 : cents) / 100;
    try {
      return new Intl.NumberFormat(cfg.locale || document.documentElement.lang || undefined, {
        style: 'currency', currency: cur, currencyDisplay: 'narrowSymbol'
      }).format(amount);
    } catch (e) {
      return (cfg.moneyFormat || '${{amount}}').replace(/\{\{\s*\w+\s*\}\}/g, amount.toFixed(2));
    }
  }

  var scrim = $('#iv-scrim'), drawer = $('#iv-drawer');
  var navScrim = $('#iv-nav-scrim'), navDrawer = $('#iv-nav'), navToggle = $('[data-open-nav]');

  function openDrawer() {
    if (!drawer) return;
    scrim.classList.add('scrim--on');
    drawer.classList.add('drawer--on');
    drawer.setAttribute('aria-hidden', 'false');
    document.body.classList.add('noscroll');
  }
  function closeDrawer() {
    if (!drawer) return;
    scrim.classList.remove('scrim--on');
    drawer.classList.remove('drawer--on');
    drawer.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('noscroll');
  }

  function openNav() {
    if (!navDrawer) return;
    navScrim.classList.add('navscrim--on');
    navDrawer.classList.add('navdrawer--on');
    navDrawer.setAttribute('aria-hidden', 'false');
    if (navToggle) navToggle.setAttribute('aria-expanded', 'true');
    document.body.classList.add('noscroll');
  }
  function closeNav() {
    if (!navDrawer) return;
    navScrim.classList.remove('navscrim--on');
    navDrawer.classList.remove('navdrawer--on');
    navDrawer.setAttribute('aria-hidden', 'true');
    if (navToggle) navToggle.setAttribute('aria-expanded', 'false');
    document.body.classList.remove('noscroll');
  }

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' })[c];
    });
  }

  var trashSvg = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" aria-hidden="true"><path d="M4 7h16M9 7V5.5A1.5 1.5 0 0 1 10.5 4h3A1.5 1.5 0 0 1 15 5.5V7M10 11v6M14 11v6M6.5 7l.8 12.2A1.5 1.5 0 0 0 8.8 20.5h6.4a1.5 1.5 0 0 0 1.5-1.3L17.5 7"/></svg>';

  function lineHtml(i, currency) {
    var img = i.image || (i.featured_image && i.featured_image.url) || '';
    var sub = i.variant_title && i.variant_title !== 'Default Title'
      ? '<div class="ci__v">' + esc(i.variant_title) + '</div>' : '';
    var thumb = img
      ? '<div class="ci__img"><img src="' + esc(img) + '" alt="" width="72" height="72"></div>'
      : '';
    var minusDisabled = i.quantity <= 1 ? ' disabled' : '';
    return '<div class="ci" data-key="' + esc(i.key) + '" data-qty="' + i.quantity + '">' +
      thumb +
      '<div class="ci__info">' +
        '<div class="ci__t">' + esc(i.product_title) + '</div>' + sub +
        '<div class="ci__tools">' +
          '<div class="qty" role="group" aria-label="Quantity">' +
            '<button type="button" class="qty__btn" data-qty-delta="-1" aria-label="Decrease quantity"' + minusDisabled + '>&minus;</button>' +
            '<span class="qty__n">' + i.quantity + '</span>' +
            '<button type="button" class="qty__btn" data-qty-delta="1" aria-label="Increase quantity">+</button>' +
          '</div>' +
          '<button type="button" class="ci__trash" data-remove="' + esc(i.key) + '" aria-label="Remove">' + trashSvg + '</button>' +
        '</div>' +
      '</div>' +
      '<div class="ci__p">' + money(i.final_line_price, currency) + '</div>' +
    '</div>';
  }

  function renderCart(cart) {
    $$('[data-cart-count]').forEach(function (el) {
      el.textContent = cart.item_count;
      el.style.display = cart.item_count ? '' : 'none';
    });
    var html = cart.items.length
      ? cart.items.map(function (i) { return lineHtml(i, cart.currency); }).join('')
      : '<p class="small" style="padding:40px 0;text-align:center">Nothing here yet.</p>';
    $$('[data-cart-lines]').forEach(function (el) { el.innerHTML = html; });
    $$('[data-cart-subtotal]').forEach(function (el) { el.textContent = money(cart.total_price, cart.currency); });
    $$('[data-cart-foot]').forEach(function (el) { el.style.display = cart.items.length ? '' : 'none'; });
    $$('[data-cart-empty]').forEach(function (el) { el.style.display = cart.items.length ? 'none' : ''; });
  }

  function changeQty(key, qty) {
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty })
    }).then(function (r) { return r.json(); }).then(renderCart);
  }

  function refreshCart(open) {
    return fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (c) { renderCart(c); if (open) openDrawer(); return c; })
      .catch(function () {});
  }

  document.addEventListener('click', function (e) {
    var t = e.target;
    if (t.closest('[data-open-cart]')) { e.preventDefault(); refreshCart(true); }
    if (t.closest('[data-close-cart]') || t.id === 'iv-scrim') { e.preventDefault(); closeDrawer(); }
    if (t.closest('[data-open-nav]')) { e.preventDefault(); openNav(); }
    if (t.closest('[data-close-nav]') || t.id === 'iv-nav-scrim') { e.preventDefault(); closeNav(); }
    var rm = t.closest('[data-remove]');
    if (rm) {
      e.preventDefault();
      changeQty(rm.getAttribute('data-remove'), 0);
    }
    var deltaBtn = t.closest('[data-qty-delta]');
    if (deltaBtn && !deltaBtn.disabled) {
      e.preventDefault();
      var row = deltaBtn.closest('[data-key]');
      if (!row) return;
      var next = parseInt(row.getAttribute('data-qty'), 10) + parseInt(deltaBtn.getAttribute('data-qty-delta'), 10);
      if (next < 1) return;
      changeQty(row.getAttribute('data-key'), next);
    }
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') { closeDrawer(); closeNav(); } });

  $$('[data-gallery]').forEach(function (g) {
    var stage = $('[data-stage-img]', g);
    var thumbs = $$('.pdp__thumb', g);
    if (!stage || !thumbs.length) return;
    thumbs.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var full = btn.getAttribute('data-full');
        if (!full) return;
        stage.src = full;
        stage.alt = btn.getAttribute('data-alt') || '';
        thumbs.forEach(function (x) {
          x.classList.toggle('pdp__thumb--on', x === btn);
          x.setAttribute('aria-pressed', x === btn ? 'true' : 'false');
        });
      });
    });
  });

  $$('.faq__q').forEach(function (q) {
    q.addEventListener('click', function () {
      var open = q.getAttribute('aria-expanded') === 'true';
      var panel = q.nextElementSibling;
      q.setAttribute('aria-expanded', open ? 'false' : 'true');
      panel.style.maxHeight = open ? null : panel.scrollHeight + 'px';
    });
  });

  var form = $('#iv-buy');
  if (form) {
    form.addEventListener('submit', function (e) { e.preventDefault(); });

    var tiers = $$('.tier', form);
    var addons = $$('.addon', form);
    var nowEl = $('[data-now]', form), wasEl = $('[data-was]', form);
    var unitEl = $('[data-unit]', form), totEl = $('[data-total]', form);
    var stickyP = $('[data-sticky-price]');

    function selectedTier() { return $('.tier--on input', form) || $('.tier input:checked', form); }

    function recalc() {
      var input = selectedTier(); if (!input) return;
      var tier = input.closest('.tier');
      var price = parseInt(tier.dataset.price, 10);
      var was = parseInt(tier.dataset.compare, 10);
      var qty = parseInt(tier.dataset.qty, 10);
      var total = price;
      addons.forEach(function (a) {
        if (a.classList.contains('addon--on')) total += parseInt(a.dataset.price, 10);
      });
      if (nowEl) nowEl.textContent = money(price);
      if (wasEl) wasEl.textContent = was > price ? money(was) : '';
      if (unitEl) {
        unitEl.textContent = qty > 1
          ? money(Math.round(price / qty)) + ' per set, you save ' + money(was - price)
          : 'You save ' + money(was - price) + ' off the full price of ' + money(was);
      }
      if (totEl) totEl.textContent = money(total);
      if (stickyP) stickyP.textContent = money(total);
    }

    tiers.forEach(function (t) {
      t.addEventListener('click', function () {
        tiers.forEach(function (x) { x.classList.remove('tier--on'); });
        t.classList.add('tier--on');
        $('input', t).checked = true;
        recalc();
      });
    });

    addons.forEach(function (a) {
      var box = $('input', a);
      if (box && box.checked) a.classList.add('addon--on');
      a.addEventListener('click', function (e) {
        e.preventDefault();
        var box = $('input', a);
        box.checked = !box.checked;
        a.classList.toggle('addon--on', box.checked);
        recalc();
      });
    });

    function addToCart(btn) {
      var input = selectedTier(); if (!input) return;
      var tier = input.closest('.tier');
      var mainId = parseInt(tier.dataset.variant, 10);
      if (!mainId) { alert('Sorry, this set is unavailable right now. Please refresh and try again.'); return; }
      var items = [{ id: mainId, quantity: 1 }];
      addons.forEach(function (a) {
        if (a.classList.contains('addon--on')) {
          var addonId = parseInt(a.dataset.variant, 10);
          if (addonId) { items.push({ id: addonId, quantity: 1 }); }
        }
      });
      var label = btn.textContent;
      btn.disabled = true; btn.textContent = 'Adding...';
      fetch('/cart/add.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: items })
      }).then(function (r) {
        return r.json().then(function (data) {
          if (!r.ok) { throw new Error(data && data.description ? data.description : 'Could not add to cart.'); }
          return data;
        });
      })
        .then(function () { window.location.assign('/checkout'); })
        .catch(function (err) {
          alert(err && err.message ? err.message : 'Sorry, we could not add that to your cart. Please try again.');
          btn.disabled = false;
          btn.textContent = label;
        });
    }

    $$('[data-add]').forEach(function (b) {
      b.addEventListener('click', function (e) { e.preventDefault(); addToCart(b); });
    });

    recalc();

    var bar = $('.stickybuy'), anchor = $('.tiers');
    if (bar && anchor && window.IntersectionObserver) {
      var io = new IntersectionObserver(function (entries) {
        bar.classList.toggle('stickybuy--on', !entries[0].isIntersecting);
      }, { rootMargin: '-120px 0px 0px 0px' });
      io.observe(anchor);
    }
  }

  refreshCart(false);

  /* ---------- reviews ---------- */
  (function reviews() {
    var root = $('[data-reviews]');
    if (!root) return;
    var cfg = window.IronVowReviews || {};
    var photos = cfg.photos || [];
    var PAGE = 3;
    var AV = ['#1B4A57', '#3A2E22', '#2A3D2E', '#4A2A28', '#243044', '#3E3420', '#2C3530', '#4A3B1F'];

    var fallback = [
      { n: 'Marcus T.', loc: 'Columbus OH', d: '2026-06-18', s: 5, t: 'Everyone who walks in goes straight to it', b: 'Way better in person than the pictures show. The plush is heavy and the house crest is embroidered, not printed. I put it on for a movie night and have not taken it off. It lives on the hook by the door now.', h: 88 },
      { n: 'Rachel B.', loc: 'Boise ID', d: '2026-06-14', s: 5, t: 'First thing anyone notices', b: 'Got this for my husband\'s birthday. He has had the same three books on that shelf for a decade and now this is the first thing anyone notices when they come over. The crest on the chest is a nice touch. Arrived in 9 days, packaging was solid.', h: 81 },
      { n: 'Devin O.', loc: 'Portland OR', d: '2026-06-11', s: 5, t: 'Holds up next to pieces I paid a lot more for', b: 'I buy a lot of merch and this holds up next to pieces I paid a lot more for. The lining is soft, the embroidery is clean, and the fit is relaxed like they said. I wish it had pockets on both sides, but I still wear it every night.', h: 74 },
      { n: 'Priya S.', loc: 'Austin TX', d: '2026-06-02', s: 5, t: 'Bought it for myself and no regrets', b: 'Got tired of waiting for someone to buy me something I actually wanted. Opened it, put it on, and just sat there. The house colors are my favorite. Feels like a real robe and not a costume.', h: 63 },
      { n: 'Aaron K.', loc: 'Denver CO', d: '2026-05-28', s: 5, t: 'The fit is the whole thing', b: 'Most robes like this run cheap and thin. This one arrives heavy. Soft plush, crest on the chest, a cut you can live in. I put it on after work and stopped fussing with it. That is what I wanted.', h: 81 },
      { n: 'Tyler M.', loc: 'Chicago IL', d: '2026-05-30', s: 5, t: 'Detail is way better than the photos', b: 'Photos flatten it. In hand the fabric has weight, the embroidery is not a sticker, and it actually keeps you warm. My roommate thought it was a custom piece. It is not. That is the point.', h: 59 },
      { n: 'Chris D.', loc: 'Tampa FL', d: '2026-05-22', s: 4, t: 'Solid robe, shipping took a minute', b: 'Quality is there. The plush and the crest look like they came from a real shop, in a good way. Took 11 business days to show up, which they did warn about. No damage, packed well.', h: 41 },
      { n: 'Jordan W.', loc: 'Seattle WA', d: '2026-05-19', s: 5, t: 'Gift that actually landed', b: 'Bought it for my dad. He is impossible to shop for. He put it on at the kitchen table and did not look at his phone for twenty minutes. That is a win in this house.', h: 67 },
      { n: 'Nathan R.', loc: 'Nashville TN', d: '2026-05-17', s: 5, t: 'Good size, not a costume', b: 'I was worried it would look like a cheap Halloween robe. It does not. Relaxed through the body, hits where it should. I wear it for reading and it looks like it belongs, not like a costume leftover.', h: 55 },
      { n: 'Maya L.', loc: 'Brooklyn NY', d: '2026-05-12', s: 4, t: 'Looks expensive, because it kind of is', b: 'Not cheap, and I knew that going in. Stitching is clean, no loose threads out of the box. Minus one star because I wanted it a little longer. Fine as is. Would still buy it again.', h: 38 },
      { n: 'Owen H.', loc: 'Minneapolis MN', d: '2026-05-08', s: 5, t: 'The crest on the chest sold me', b: 'I almost skipped it thinking it was just a plain robe. The house embroidery makes it feel like yours. Sat on the couch in it. Wife did not make me take it off.', h: 72 },
      { n: 'Samira K.', loc: 'San Diego CA', d: '2026-05-04', s: 5, t: 'Packaging was overkill in the best way', b: 'Came double boxed and folded clean. Nothing crushed. I am picky about merch and this one does not feel thin or cheap.', h: 49 },
      { n: 'Brett C.', loc: 'Kansas City MO', d: '2026-04-29', s: 4, t: 'Better than the thin one I had', b: 'Replaced a cheap fleece robe I bought years ago. Night and day. Heavy plush, real embroidery, a fit that does not cling. Took a day longer than the estimate. Still worth it.', h: 33 },
      { n: 'Elena V.', loc: 'Pittsburgh PA', d: '2026-04-21', s: 5, t: 'The embroidery is the detail I keep pointing at', b: 'People ask if the crest is printed. It is stitched. I like that nobody has to squint to see the house. Looks finished, not like a blank robe with a patch stuck on.', h: 61 },
      { n: 'Liam P.', loc: 'Calgary AB', d: '2026-04-16', s: 5, t: 'Showed up in Canada without drama', b: 'Ordered on a Sunday, had it the following week plus a couple days. Duties were clear at checkout. Robe looks the same as the site photos, which is rarer than it should be.', h: 44 },
      { n: 'Harper J.', loc: 'Raleigh NC', d: '2026-04-09', s: 4, t: 'A little roomier than I pictured, in a good way', b: 'I thought it would be tight through the shoulders. It is not. Relaxed like they said. I still catch myself wearing it to make coffee, which I probably should not do with guests around.', h: 29 },
      { n: 'Diego M.', loc: 'Phoenix AZ', d: '2026-04-03', s: 5, t: 'Movie nights that do not look like pajamas', b: 'Put it on for a film and people notice it. The house colors and the crest are the two they ask about. Soft, no fuss, no cheap shine.', h: 52 },
      { n: 'Nora F.', loc: 'Madison WI', d: '2026-03-27', s: 5, t: 'Exactly what I wanted for cold mornings', b: 'We redid the living room and this was the last piece of the vibe. Dark plush against the couch is the whole look. Thirty-day window made me comfortable ordering. Did not need it.', h: 47 },
      { n: 'Kai E.', loc: 'Honolulu HI', d: '2026-03-19', s: 4, t: 'Longer shipping, same quality', b: 'Took the full 12 business days to the islands, as expected. Box was scuffed, the robe was not. I would like a hood, but that is me being precious about it.', h: 26 },
      { n: 'Avery Q.', loc: 'Ottawa ON', d: '2026-03-11', s: 5, t: 'Paid in CAD, no surprise at the door', b: 'Price on the site matched what I paid. Robe feels heavy in a way cheap imports do not. The embroidery and the fit are why it works as a gift and not a costume.', h: 58 },
      { n: 'Jonah S.', loc: 'Salt Lake City UT', d: '2026-03-04', s: 5, t: 'Put it on in a minute, wore it for an hour', b: 'No fuss. The weight of the plush surprised me. Soft, as promised, which I needed with a kid in the house who likes to steal it.', h: 36 }
    ];
    var raw = (cfg.items && cfg.items.length) ? cfg.items : fallback;
    var pool = raw.map(function (r) {
      return {
        n: r.n || '',
        loc: r.loc || '',
        d: r.d || '',
        s: parseInt(r.s, 10) || 5,
        t: r.t || '',
        b: r.b || '',
        h: parseInt(r.h, 10) || 0
      };
    });

    function hash(s) {
      var h = 0, i;
      for (i = 0; i < s.length; i++) h = ((h << 5) - h + s.charCodeAt(i)) | 0;
      return Math.abs(h);
    }
    function shuffle(arr) {
      var a = arr.slice(), i, j, t;
      var seed = hash((sessionStorage.getItem('iv-rev-seed') || (sessionStorage.setItem('iv-rev-seed', String(Math.random())), sessionStorage.getItem('iv-rev-seed'))));
      function rnd() { seed = (seed * 16807) % 2147483647; return (seed - 1) / 2147483646; }
      for (i = a.length - 1; i > 0; i--) { j = Math.floor(rnd() * (i + 1)); t = a[i]; a[i] = a[j]; a[j] = t; }
      return a;
    }
    function fmtDate(iso) {
      try {
        return new Date(iso + 'T12:00:00').toLocaleDateString(undefined, { month: 'long', day: 'numeric', year: 'numeric' });
      } catch (e) { return iso; }
    }
    function stars(n) {
      var s = '', i;
      for (i = 1; i <= 5; i++) s += '<span class="stars__i' + (i > n ? ' is-off' : '') + '">★</span>';
      return '<span class="stars" aria-label="' + n + ' out of 5">' + s + '</span>';
    }
    function initials(name) {
      var p = name.replace('.', '').split(/\s+/);
      return ((p[0] && p[0][0]) || '') + ((p[1] && p[1][0]) || '');
    }

    var reviewColors = cfg.colors || {};

    var reviews = shuffle(pool).map(function (r, i) {
      r.id = 'r' + i;
      r.color = reviewColors.avatar || AV[hash(r.n) % AV.length];
      return r;
    });
    var liked = {};
    try { liked = JSON.parse(localStorage.getItem('iv-rev-liked') || '{}') || {}; } catch (e) { liked = {}; }

    var filter = 'all', sort = 'featured', shown = PAGE;
    var list = $('[data-rev-list]', root);
    var moreBtn = $('[data-rev-more]', root);

    function visible() {
      var rows = reviews.filter(function (r) {
        return filter === 'all' || String(r.s) === filter;
      });
      if (sort === 'newest') rows.sort(function (a, b) { return a.d < b.d ? 1 : -1; });
      else if (sort === 'highest') rows.sort(function (a, b) { return b.s - a.s || b.h - a.h; });
      else rows.sort(function (a, b) { return b.h - a.h; });
      return rows;
    }

    function render() {
  var nameAttr = reviewColors.name ? ' style="color:' + reviewColors.name + '"' : '';
  var rows = visible();
  var slice = rows.slice(0, shown);
  if (!slice.length) {
    list.innerHTML = '<p class="revs__empty">No reviews in this filter yet.</p>';
    moreBtn.style.display = 'none';
    return;
  }
  var cardStyle = '';
  if (reviewColors.cardBg) cardStyle += 'background:' + reviewColors.cardBg + ';';
  if (reviewColors.cardBorder) cardStyle += 'border-color:' + reviewColors.cardBorder + ';';
  var cardAttr = cardStyle ? ' style="' + cardStyle + '"' : '';
  var verifiedAttr = reviewColors.verified ? ' style="color:' + reviewColors.verified + '"' : '';
  var textAttr = reviewColors.text ? ' style="color:' + reviewColors.text + '"' : '';

  list.innerHTML = slice.map(function (r) {
    var count = r.h + (liked[r.id] ? 1 : 0);
    return '<article class="rev"' + cardAttr + '>' +
      '<div class="rev__top">' +
        '<div class="rev__av" style="background:' + r.color + '">' + esc(initials(r.n)) + '</div>' +
        '<div>' +
          '<div class="rev__name"' + nameAttr + '>' + esc(r.n) +
            '<span class="rev__ok"' + verifiedAttr + '><svg viewBox="0 0 12 12" fill="none" stroke="currentColor" stroke-width="2"><path d="M2 6.5l2.4 2.4L10 3.2"/></svg> Verified</span>' +
          '</div>' +
          '<div class="rev__date">' + esc(fmtDate(r.d)) + '</div>' +
        '</div>' +
      '</div>' +
      '<div class="rev__stars">' + stars(r.s) + '</div>' +
      '<h3 class="rev__title"' + textAttr + '>' + esc(r.t) + '</h3>' +
      '<p class="rev__body"' + textAttr + '>' + esc(r.b) + '</p>' +
      '<button type="button" class="rev__help' + (liked[r.id] ? ' is-on' : '') + '" data-help="' + r.id + '" aria-pressed="' + (liked[r.id] ? 'true' : 'false') + '">' +
        '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7"><path d="M7 11v9H4v-9h3Zm3 9h7.2a2 2 0 0 0 1.9-1.4l1.4-5.2A1.5 1.5 0 0 0 19 11h-5l.8-4.2a1.2 1.2 0 0 0-2.1-1L8.5 11H10v9Z"/></svg>' +
        'Helpful (' + count + ')' +
      '</button>' +
    '</article>';
  }).join('');
  moreBtn.style.display = shown >= rows.length ? 'none' : '';
}

    var sum = reviews.reduce(function (a, r) { return a + r.s; }, 0);
    var avg = (sum / reviews.length).toFixed(1);
    var avgEl = $('[data-rev-avg]', root);
    var cntEl = $('[data-rev-count]', root);
    if (avgEl) avgEl.textContent = avg + ' out of 5';
    if (cntEl) cntEl.textContent = reviews.length + ' reviews';

    $$('[data-rev-filter]', root).forEach(function (btn) {
      btn.addEventListener('click', function () {
        filter = btn.getAttribute('data-rev-filter');
        shown = PAGE;
        $$('[data-rev-filter]', root).forEach(function (b) { b.classList.toggle('revs__pill--on', b === btn); });
        render();
      });
    });
    var sortEl = $('[data-rev-sort]', root);
    if (sortEl) sortEl.addEventListener('change', function () { sort = sortEl.value; shown = PAGE; render(); });
    if (moreBtn) moreBtn.addEventListener('click', function () { shown += PAGE; render(); });
    list.addEventListener('click', function (e) {
      var b = e.target.closest('[data-help]');
      if (!b) return;
      var id = b.getAttribute('data-help');
      liked[id] = !liked[id];
      try { localStorage.setItem('iv-rev-liked', JSON.stringify(liked)); } catch (err) {}
      render();
    });
    render();
  })();

  function pad2(v) {
    return v < 10 ? '0' + v : String(v);
  }

  $$('[data-urgency]').forEach(function (root) {
    var min = parseInt(root.getAttribute('data-view-min'), 10);
    var max = parseInt(root.getAttribute('data-view-max'), 10);
    if (isNaN(min)) min = 12;
    if (isNaN(max)) max = 28;
    if (min > max) { var swap = min; min = max; max = swap; }
    var viewersEl = $('[data-viewers]', root);
    var n = min + Math.floor(Math.random() * (max - min + 1));
    function paintViewers() {
      if (viewersEl) viewersEl.textContent = String(n);
    }
    paintViewers();
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (!reduce) {
      setInterval(function () {
        n += Math.random() < 0.55 ? 1 : -1;
        if (n < min) n = min;
        if (n > max) n = max;
        paintViewers();
      }, 2800);
    }

    var hEl = $('[data-cd-h]', root);
    var mEl = $('[data-cd-m]', root);
    var sEl = $('[data-cd-s]', root);
    if (!hEl || !mEl || !sEl) return;
    function tick() {
      var now = new Date();
      var end = new Date(now.getFullYear(), now.getMonth(), now.getDate() + 1);
      var tot = Math.max(0, Math.floor((end - now) / 1000));
      hEl.textContent = pad2(Math.floor(tot / 3600));
      mEl.textContent = pad2(Math.floor((tot % 3600) / 60));
      sEl.textContent = pad2(tot % 60);
    }
    tick();
    setInterval(tick, 1000);
  });
})();
